// extracted by mini-css-extract-plugin
export default {"onlyDark":"HomeWorkExperience_onlyDark__CcyLI","onlyLight":"HomeWorkExperience_onlyLight__DYlGx"};